import React from 'react';

interface ButtonToggleProps
	extends React.ButtonHTMLAttributes<HTMLButtonElement> {
	isOn: boolean;
	toggle: () => void;
}

const Button_Toggle: React.FC<ButtonToggleProps> = ({
	isOn,
	toggle,
	...props
}) => {
	return (
		<button
			aria-label="toggle"
			type="button"
			onClick={toggle}
			className={`relative min-w-12 w-12 h-7 rounded-full transition-colors duration-200 ${
				isOn ? ' bg-electric-sky' : 'bg-background-color'
			}`}
			{...props}
		>
			<span
				className={`absolute top-0.5 left-0.5 w-6 h-6 rounded-full  bg-dove-white transition-transform duration-200 ${
					isOn ? 'translate-x-5' : ''
				}`}
			/>
		</button>
	);
};

export default Button_Toggle;
